import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.space',
    'resource:data.dimensions.spaceSurveyConfigurations.entities.spaceSurveyConfig.attributes.allowUsersToUnlockRoomsDirectly',
    'resource:data.dimensions.spaceSurveyConfigurations.entities.spaceSurveyConfig',
    'resource:data.dimensions.spaceSurveyConfigurations',
    'resource:data.enums.anomaly.entries.incorrectDoorNumber',
    'resource:data.enums.anomaly.entries.incorrectFloorPlan',
    'resource:data.enums.anomaly.entries.roomDoesNotExists',
    'resource:data.enums.anomaly',
    'resource:data.enums.spaceSurveyStatus.entries.notStarted',
    'resource:data.enums.spaceSurveyStatus.entries.inProgress',
    'resource:data.enums.spaceSurveyStatus.entries.signedOff',
    'resource:data.enums.spaceSurveyStatus',
    'resource:data.enums.spaceSurveyFuncMethod.entries.jointUse',
    'resource:data.enums.spaceSurveyFuncMethod.entries.serviceCenter',
    'resource:data.enums.spaceSurveyFuncMethod.entries.vacant',
    'resource:data.enums.spaceSurveyFuncMethod.entries.unassignable',
    'resource:data.enums.spaceSurveyFuncMethod.entries.manual',
    'resource:data.enums.spaceSurveyFuncMethod.entries.autoLabBased',
    'resource:data.enums.spaceSurveyFuncMethod',
    'resource:data.dimensions.space.snapshots.survey.attributes.funcMethod',
    'resource:data.dimensions.space.snapshots.survey.attributes.comment',
    'resource:data.dimensions.space.snapshots.survey.attributes.status',
    'resource:data.dimensions.space.snapshots.survey.attributes.statusLite',
    'resource:data.dimensions.space.snapshots.survey.attributes.anomalies',
    'resource:data.dimensions.space.snapshots.survey.attributes.history',
    'resource:data.dimensions.space.snapshots.survey.attributes.activePeriods',
    'resource:data.dimensions.space.snapshots.survey.attributes.lastUpdatedBy',
    'resource:data.dimensions.space.snapshots.survey',
    'resource:data.dimensions.organization',
    'resource:data.dimensions.organization.entities.division',
    'resource:data.dimensions.organization.entities.department',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.organization',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.space',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.isOccupier',
    'resource:data.dimensions.organizationSpace.entities.entry',
    'resource:data.dimensions.organizationSpace',
    'resource:data.dimensions.space.snapshots.previousOccupier.attributes.activePeriods',
    'resource:data.dimensions.space.snapshots.previousOccupier.attributes.previousOccupier',
    'resource:data.dimensions.space.snapshots.previousOccupier.attributes.changedBy',
    'resource:data.dimensions.space.snapshots.previousOccupier',
    'resource:data.dimensions.spaceUserAccess.entities.entry.attributes.organization',
    'resource:data.dimensions.spaceUserAccess.entities.entry.attributes.isSurveyAdmin',
    'resource:data.dimensions.spaceUserAccess.entities.entry.attributes.userId',
    'resource:data.dimensions.spaceUserAccess.entities.entry',
    'resource:data.dimensions.spaceUserAccess',
    'resource:data.dimensions.idcFunctions.entities.category',
    'resource:data.dimensions.idcFunctions.entities.subcategory',
    'resource:data.dimensions.idcFunctions',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.idcFunction',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.isExclusive',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.isRequiredForMatchingPayroll',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.isSponsored',
    'resource:data.dimensions.spaceFunctions.entities.function.records.unassignable',
    'resource:data.dimensions.spaceFunctions.entities.function.records.vacant',
    'resource:data.dimensions.spaceFunctions.entities.function',
    'resource:data.dimensions.spaceFunctions',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.spaceFunction',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.space',
    'resource:data.dimensions.spaceFunctionalization.entities.entry',
    'resource:data.dimensions.spaceFunctionalization',
  ],
  description: 'TODO',
  name: 'Data - Space',
} as const satisfies core.quiver.Package
